import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import ShareTipComponent from '../components/share-tip/share-tip.jsx';

class ShareTip extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
        ]);
        this.state = {
        };
    }
    render () {
        return (
            <ShareTipComponent />
        );
    }
}

ShareTip.propTypes = {
    // onQuestionAnswered: PropTypes.func.isRequired,
    // question: PropTypes.string
};

export default ShareTip;
